<template>
  <div class="ai rt60">
    <div>
      <banner :child-data="fdata"></banner>

    </div>
  </div>
</template>
<script>
import topNav from "../components/top";
import banner from "../components/banner";
import footerBot from "../components/footerBot";
import { mapMutations } from "vuex";
export default {
  name: "about",
  data() {
    return {
      fdata: {
        h1: "404, Not Found",
        h2: "",
        style: {
          background: "black"
        }
      },
      formData: new FormData(),
      img0: {},
      text: "123"
    };
  },
  components: {
    topNav,
    banner,
    footerBot
  },
  methods: {
    addActive(val) {
      this.menu = val;
    },
    ...mapMutations(["editMenu"])
  },
  mounted() {
    this.editMenu("about");
  }
};
</script>

<style scoped>
.settab .flexRow > div {
  text-align: left;
  padding: 20px;
}
.settab .flexRow h3 {
  font-size: 22px;
}
.settab .flexRow p {
  font-size: 14px;
}
.vjs-tech {
  width: 100%;
}
#headerwrap h2 {
  font-size: 20px;
  text-align: left;
}
blockquote {
  border: none;
}
#navbar-main {
  /* height: 144px; */
}
#about-main {
  padding-bottom: 30px;
}
#headerwrap {
  /* background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center top; */
  display: flex;
  align-items: center;
  justify-content: center;
}
#headerwrap h1 {
  margin-top: 0;
}

#headerwrap h2 {
  color: white;
  margin-bottom: 0;
}

#ai-main .img-banner {
  height: 380px;
  width: 100%;
  /* background: url(img/about/gyks_banner@3x.jpg) no-repeat 100% center; */
  background-size: 100% 100%;
  box-sizing: border-box;
}

#ai-main .img-banner h3 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  padding: 18px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link h3 {
  font-size: 18px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link p {
  font-size: 14px;
  margin-bottom: 8px;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link p:last-child {
  margin-bottom: 0px;
}
@media screen and (max-width: 480px) {
  #ai-main .img-banner {
    height: 170px;
    width: 100%;
    background: url(../../public/img/about/gyks_banner@3x.jpg) no-repeat center;
    background-size: 100% 100%;
  }
}
#ai-main .company-info {
  /* padding: 20px 0px; */
  box-sizing: border-box;
}
.company-develop {
  padding-top: 40px;
}
#ai-main .info-title,
#ai-main .develop-title {
  text-align: center;
  margin-bottom: 30px;
  margin-top: 20px;
}
#ai-main .info-main {
  display: flex;
  flex-direction: column;
  /* align-items: ; */
}
#ai-main .info-title .title-text,
#ai-main .develop-title .title-text {
  font-size: 30px;
}

.tab-content {
  background-color: #fff;
  border: 1px solid #ddd;
  border-top: 0;
  padding: 15px 15px 5px;
  box-sizing: border-box;
}

.well {
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.05);
}

#headerwrap p {
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
}
.btn-outline-primary {
  color: black;
  border-color: #ccc;
}
.btn-outline-primary:hover {
  color: white;
}
.advantage {
  display: flex;
}
.advantage_sec {
  flex: 1;
  padding: 0px 40px;
}
.advantage_sec .p20 {
  padding-right: 30px;
  text-align: left;
}
.advantage_sec .p20 h3 {
  font-size: 18px;
}
.advantage_sec .p20 p {
  font-size: 14px;
}
.card-deck:nth-child(n + 1) {
  margin-top: 30px;
}
.card-text {
  text-align: left;
}
.card {
  border: none;
  background: unset;
}
.ai-scene {
  padding: 60px;
}
.ai-scene .card {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ai-scene .card .card-body {
  text-align: left;
}
.ai-scene .card img {
  width: 50%;
}

.ai-parter {
  background: cadetblue;
  padding: 60px;
}
.partner-sec {
  display: flex;
  align-items: center;
  justify-content: center;
}
.partner-sec > div {
  padding: 20px;
  flex: 1;
  background: white;
  margin-right: 20px;
}
.ai-parter .develop-title .title-text {
  color: white;
}
.ai-feature {
  padding: 0px 0px 60px;
}
.ai-sec .advantage,
.ai-feature .advantage {
  padding: 25px 0px 40px;
  display: flex;
  flex-wrap: wrap;
}
.ai-sec .advantage > div,
.ai-feature .advantage > div {
  width: 48%;
  flex: auto;
}
.fileGroup {
  display: flex;
  justify-content: space-around;
  height: 350px;
}

.imgBottom {
  position: absolute;
  bottom: 0;
}

.fileGroup > div {
  width: 48%;
  position: relative;
}

.fileGroup .json_right {
  border: 1px solid lightgray;
}

.fileGroup .imgShow {
  width: 100%;
  height: 300px;
  border: 1px solid lightgray;
}
.fileGroup .imgShow img {
  /* width: 100%; */
  height: 100%;
}
.fileGroup .json_right {
  background: aliceblue;
}
#file0,
#file1,
#file2,
#file3,
#file4,
#file5,
#file6,
#file7 {
  display: none;
}
.fileGroup .tips {
  position: absolute;
  left: 0;
  top: 0;
  padding: 5px 10px;
  background-color: #e6fafd;
  font-size: 14px;
  color: gray;
}
.btn-group {
  margin-bottom: 20px;
}
.imgSec {
  width: 100%;
  height: 100%;
  overflow: hidden;
  list-style-type: none;
}
.compare {
  width: 20%;
  margin-top: 30px;
}

.anchor {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.anchor a {
  color: black;
  padding: 8px;
}
a:hover {
  text-decoration: none;
  font-weight: bold;
  border-bottom: 2px solid black;
}
.car_top {
  display: flex;
  border-bottom: 1px solid #ccc;
}
.car_bot {
  margin-top: 20px;
}
.car_bot div {
  display: flex;
  align-items: center;
  /* justify-content: space-evenly; */
  margin-top: 20px;
}
.car_bot div span {
  /* display: inline-block; */
  width: 80px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  background-color: white;
}
.ai-advantage,
.ai-solution,
.ai-sec {
  padding: 60px 0px;
}
.ai-solution .tab-content .card-text {
  display: flex;
}
.ai-solution .tab-content .card-text .card_le {
  flex: 3;
}
.ai-solution .tab-content .card-text .card_ri {
  flex: 1;
}
.function .card .card-text {
  margin: 0 auto;
  text-align: center !important;
}
.hardtab {
  display: flex;
  align-items: center;
}
.hardtab .con_le {
  text-align: left;
  padding-left: 20px;
}
.function .card img {
  width: 80px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 24px;
}

@media screen and (max-width: 480px) {
  .hardtab {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .hardtab .con_ri img {
    width: 100%;
  }
}
.rt60 {
  position: relative;
  top: -60px;
    margin-bottom: -60px;
}
</style>
